import { render, staticRenderFns } from "./ActualizarSeccionModal.vue?vue&type=template&id=1d7f4036"
import script from "./ActualizarSeccionModal.vue?vue&type=script&lang=js"
export * from "./ActualizarSeccionModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports